// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"140":"ee090549","158":"07cfdf26","560":"b0173876"}[chunkId] + ".chunk.js";
};